export default __webpack_public_path__ + "static/media/order_date.f31fc031.svg";